import React from 'react';

const Paragraph = ({ children }) => <div className="p">{ children }</div>; // eslint-disable-line

export default Paragraph;
